import React from 'react';
import styled from 'styled-components';
import layoutStyles from 'admin-components/styles/layout';
import whitelistProps from 'admin-components/utils/whitelistProps';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';
import { Container as StyledContainer } from './Container.styles';
import { propTypes, defaultProps, propDescriptions } from './Container.props';

const Container = (props) => {
  const { children, childrenWidth, additionalProptypes, id } = props;
  let childWidth;
  if (childrenWidth) {
    if (typeof childrenWidth === 'object') {
      childWidth = {
        xs: childrenWidth.xs === 'even' ? 12 / children.length : childrenWidth.xs,
        sm: childrenWidth.sm === 'even' ? 12 / children.length : childrenWidth.sm,
        md: childrenWidth.md === 'even' ? 12 / children.length : childrenWidth.md,
        lg: childrenWidth.lg === 'even' ? 12 / children.length : childrenWidth.lg,
        xl: childrenWidth.xl === 'even' ? 12 / children.length : childrenWidth.xl
      };
    } else {
      childWidth = childrenWidth === 'even' ? 12 / children.length : childrenWidth;
    }
  }

  return (
    <StyledContainer data-id="Container" data-cy={id} data-testid={id} {...whitelistProps(props, { ...propTypes, ...additionalProptypes })}>
      {React.Children.map(children, (child) => {
        if (child) {
          let ChildType;
          const childLayoutProps = {
            space: (child.props && child.props.space) || props.spaceChildren,
            spaceWithin: (child.props && child.props.spaceWithin) || props.spaceChildrenWithin,
            width: (child.props && child.props.width) || childWidth
          };

          /**
           * convert to styled component if not already
           */
          if (!React.isValidElement(child)) {
            ChildType = styled(StrippedBackElement).attrs({
              element: 'span'
            })`
              ${layoutStyles};
            `;

            return <ChildType {...childLayoutProps}>{child}</ChildType>;
          }
          if (typeof child.type === 'string') {
            ChildType = styled(StrippedBackElement).attrs({
              element: child.type
            })`
              ${layoutStyles};
            `;

            return <ChildType {...childLayoutProps} {...child.props} />;
          }

          return React.cloneElement(child, {
            ...child.props,
            ...childLayoutProps
          });
        }

        return null;
      })}
    </StyledContainer>
  );
};

Container.propTypes = propTypes;
Container.propDescriptions = propDescriptions;
Container.defaultProps = defaultProps;

export default Container;
